<template>
  <div
    class="app"
  >
    <main-menu />
    <transition name="default-opacity-transition" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import MainMenu from '@/domain/components/layout/Menu';

export default {
  components: {
    MainMenu,
  },
};
</script>
